// @flow weak

import PropTypes from 'prop-types';
import PureRenderMixin from 'react-addons-pure-render-mixin';
import React from 'react';
import _ from 'lodash';
import createReactClass from 'create-react-class'; // eslint-disable-line no-restricted-syntax

const MaybeLoad = createReactClass({
  displayName: 'MaybeLoad',
  mixins: [PureRenderMixin],
  hasMounted: (null: ?boolean),

  propTypes: {
    Component: PropTypes.func.isRequired,
    shouldLoad: PropTypes.func.isRequired,
    onLoad: PropTypes.func.isRequired,
  },

  getDefaultProps() {
    return {
      // By default, only load on the initial
      // mount of the component.
      shouldLoad: hasMounted => !hasMounted,
    };
  },

  loadIfDesired(nextProps) {
    const { hasMounted, props } = this;
    if (props.shouldLoad(hasMounted, { prevProps: props, nextProps })) {
      props.onLoad(nextProps);
    }
  },

  UNSAFE_componentWillMount() {
    this.hasMounted = false;
    this.loadIfDesired(this.props);
    this.hasMounted = true;
  },

  UNSAFE_componentWillUpdate(nextProps) {
    this.loadIfDesired(nextProps);
  },

  render() {
    const { Component } = this.props;
    const props = _.omit(this.props, 'Component', 'shouldLoad', 'onLoad');
    return <Component {...props} />;
  },
});

export default MaybeLoad;
